module.exports = __webpack_public_path__ + "static/media/logo_lvn_white.d7324222.png";